import {NgModule} from "@angular/core";
import {
  ManagementAndStaffsComponent
} from "../stp-registration/components/management-and-staffs/management-and-staffs.component";
import {
  ManagementAndStaffsListComponent
} from "../stp-registration/components/management-and-staffs/management-and-staffs-list/management-and-staffs-list.component";
import {
  ManagementAndStaffsCreateComponent
} from "../stp-registration/components/management-and-staffs/management-and-staffs-create/management-and-staffs-create.component";
import {
  OccupationSpecificToolsComponent
} from "../stp-registration/components/occupation-specific-tools/occupation-specific-tools.component";
import {
  OccupationSpecificToolsCreateComponent
} from "../stp-registration/components/occupation-specific-tools/occupation-specific-tools-create/occupation-specific-tools-create.component";
import {
  OccupationSpecificToolsListComponent
} from "../stp-registration/components/occupation-specific-tools/occupation-specific-tools-list/occupation-specific-tools-list.component";
import {BasicProfileComponent} from "../stp-registration/components/basic-profile/basic-profile.component";
import {StpTabComponent} from "../stp-registration/components/stp-tab/stp-tab.component";
import {FinancialDetailsComponent} from "../stp-registration/components/financial-details/financial-details.component";
import {StpPaymentComponent} from "../stp-registration/components/stp-payment/stp-payment.component";
import {
  OccupationSpecificTrainerComponent
} from "../stp-registration/components/occupation-specific-trainer/occupation-specific-trainer.component";
import {
  OccupationSpecificTrainerFormComponent
} from "../stp-registration/components/occupation-specific-trainer-form/occupation-specific-trainer-form.component";
import {FurnitureCreateComponent} from "../stp-registration/components/furniture-create/furniture-create.component";
import {FurnitureListComponent} from "../stp-registration/components/furniture-list/furniture-list.component";
import {PhysicalInfraComponent} from "../stp-registration/components/physical-infra-create/physical-infra.component";
import {SuccessComponent} from "../stp-registration/components/success/success.component";
import {StpApplicationsComponent} from "../stp-registration/components/stp-applications/stp-applications.component";
import {
  StpApplicationViewComponent
} from "../stp-registration/components/stp-application-view/stp-application-view.component";
import {OtpVerificationComponent} from "../stp-registration/components/otp-verification/otp-verification.component";
import {StpMainUpdateComponent} from "../stp-registration/components/stp-main-update/stp-main-update.component";
import {
  CertificateVarifyPageComponent
} from "../stp-registration/components/certificate-varify-page/certificate-varify-page.component";
import {
  RegistrationCardVarifyPageComponent
} from "../stp-registration/components/registration-card-varify-page/registration-card-varify-page.component";
import {QrCodeSTPComponent} from "../report/qr-code/qr-code.component";
import {
  StpOrganizationRepresentativeComponent
} from "../stp-registration/components/stp-organization-representative/stp-organization-representative.component";
import {AgencyComponent} from "../stp-registration/components/agency/agency/agency.component";
import {MinistryComponent} from "../stp-registration/components/ministry/ministry/ministry.component";
import {
  MinistryListComponent
} from "../stp-registration/components/ministry-list/ministry-list/ministry-list.component";
import {AgencyListComponent} from "../stp-registration/components/agency-list/agency-list/agency-list.component";
import {
  InspectionOfficerListComponent
} from "../stp-registration/components/inspection-officer/inspection-officer-list/inspection-officer-list.component";
import {
  AddInspectionOfficerComponent
} from "../stp-registration/components/inspection-officer/add-inspection-officer/add-inspection-officer.component";
import {
  PublicStpApplicationsListComponent
} from "../stp-registration/components/public-stp-applications-list/public-stp-applications-list.component";
import {
  ApplicationListStpComponent
} from "../stp-registration/components/application-list-stp/application-list-stp.component";
import {CommonModule} from "@angular/common";
import {StpRegistrationRoutingModule} from "../stp-registration/stp-registration-routing.module";
import {NgZorroAntdModule} from "../../ng-zorro-antd.module";
import {SharedModule} from "../../shared/modules/shared/shared.module";
import {FormsModule} from "@angular/forms";
import {NgxQRCodeModule} from "@techiediaries/ngx-qrcode";
import {QRCodeModule} from "angularx-qrcode";
import {LandingModule} from "../landing/landing.module";
import {ReCaptchaModule} from "../re-captcha/re-captcha.module";
import {DashboardComponent} from "./components/dashboard/dashboard.component";
import {NzCollapseModule} from "ng-zorro-antd/collapse";

@NgModule({
  declarations: [
    DashboardComponent
  ],
  imports: [
    CommonModule,
    StpRegistrationRoutingModule,
    NgZorroAntdModule,
    SharedModule,
    FormsModule,
    NgxQRCodeModule,
    QRCodeModule,
    LandingModule,
    ReCaptchaModule,
    NzCollapseModule
  ],
  exports: [

  ],
})
export class StpDashboardModule {}
